import {SalesTotalsActions} from '../actions/consts';
import {SalesTotals} from "~/apps/pos/models";
import {Decimal} from "decimal.js";


type SalesTotalsUIState = {
  loading: false,
  errorMessage: string,
  data: SalesTotals
};

type SalesTotalsState = {
  ui: SalesTotalsUIState,
};

const defaultState: SalesTotalsState = {
  ui: {
    loading: false,
    errorMessage: '',
    data: {totalAmountOfSales: new Decimal(0), totalCountOfSales: 0},
  }
};

export function salesTotals(state: SalesTotalsState = defaultState, action) {
  switch (action.type) {
    case SalesTotalsActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case SalesTotalsActions.LOAD_SUCCESS:
      const {totalAmountOfSales, totalCountOfSales} = action;

      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          data: {totalAmountOfSales, totalCountOfSales}
        }
      };
    case SalesTotalsActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
          data: defaultState.ui.data
        }
      };
    default:
      return state;
  }
}
